if (window.innerWidth < 768) {

    // slider for product on collection page
    // if (document.querySelector('.collection-main-body')) {
    //     document.querySelector(".collection-main-body-inner").classList.add("swiper-wrapper");
    //     let slides = document.querySelectorAll(".grid__item");
    //     slides.forEach(slide => {
    //         slide.classList.add("swiper-slide");
    //     });
    //     setTimeout(() => {
    //         const swiper = new Swiper(document.querySelector('.collection-main-body'), {
    //             slidesPerView: "auto",
    //             spaceBetween: 20,
    //             slidesToScroll: 1,
    //             mousewheelControl: true,
    //             keyboardControl: true,
    //         });
    //     }, 200);
    // }

    if (document.querySelector('.collection-main-body')) {

        let products = document.querySelectorAll(".collection-main-body-inner .grid__item")
        products.forEach((product, index) => {

            product.querySelector(".aspect-ratio").classList.add("swiper-wrapper");
            product.querySelector(".grid__image--hover").remove();
            let slides = product.querySelectorAll(".responsive-image-wrapper");
            slides.forEach(slide => {
                slide.classList.remove("hidden");
                slide.classList.add("swiper-slide");
            });

            setTimeout(() => {
                const swiper = new Swiper(product.querySelector('.grid__image__match'), {
                    slidesPerView: 1,
                    spaceBetween: 20,
                    slidesToScroll: 1,
                    mousewheelControl: true,
                    keyboardControl: true,
                });
                setTimeout(() => {
                    swiper.slideNext(400, 0);
                }, (index+1)*2000);
                setTimeout(() => {
                    swiper.slidePrev(400, 0);
                }, (index+1)*3000);
            }, 2000);
        });

    }


}
